export default __webpack_public_path__ + "static/media/6.9207ebb1.jpg";